import React from 'react';
export const areYouStrangeString = (record, source, maxLength) => {
    const message = record[source];
    if(message) {
       if(message.split(' ').some(function(subst){return subst.length > 15})){
          let inner = message.replace(RegExp("(\\w{" + 2 + "})(\\w)", "g"), function(all,text,char){ 
             return text + "<wbr>" + char; 
           }); 
          return maxLength ? <span dangerouslySetInnerHTML={{__html:inner.substring(0, maxLength)}}/> :  <span dangerouslySetInnerHTML={{__html:inner}}/> 
       }
    }
    return maxLength ? message.substring(0, maxLength) : message;
 }